import "react-virtualized/styles.css";

import React from "react";
import { AutoSizer, List as ListBase, ListProps } from "react-virtualized";
import { ClassNames } from "@emotion/core";
import Box from "../Box/Box";
import { getFacetedSearchStyles, getUserCasesStyles } from "./styles";
import { SxStyleProp } from "theme-ui";

export interface Props {
  sx?: SxStyleProp;
  height?: number;
  width?: number;
  rowRenderer: ListProps["rowRenderer"];
  rowHeight: ListProps["rowHeight"];
  rowCount: ListProps["rowCount"];
  onRowsRendered?: ListProps["onRowsRendered"];
  variant?: "facetedSearch" | "userCases";
  ref?: any;
}

const Base: React.FunctionComponent<Props> = React.forwardRef(
  (
    {
      sx,
      width,
      height,
      rowHeight,
      rowRenderer,
      rowCount,
      onRowsRendered,
      variant = "facetedSearch",
      ...restProps
    },
    ref,
  ) => {
    const getListStyles = ({ css }: any) => {
      switch (variant) {
        case "facetedSearch":
          return getFacetedSearchStyles({ css });
        case "userCases":
          return getUserCasesStyles({ css });
        default:
          return getFacetedSearchStyles({ css });
      }
    };
    return (
      <Box sx={sx}>
        <ClassNames>
          {({ css }) => (
            <ListBase
              ref={ref as any}
              rowHeight={rowHeight}
              rowRenderer={rowRenderer}
              rowCount={rowCount}
              onRowsRendered={onRowsRendered}
              width={width!}
              height={height!}
              className={getListStyles({ css })}
              {...restProps}
            />
          )}
        </ClassNames>
      </Box>
    );
  },
);

const List: React.FunctionComponent<Props> = React.forwardRef(
  ({ width = 0, height = 0, ...restProps }, ref) => {
    // If no width/height passed, use AutoSizer
    if (!width || !height) {
      return (
        <AutoSizer>
          {({ width: autoWidth, height: autoHeight }) => (
            <Base
              ref={ref}
              width={autoWidth || width}
              height={autoHeight || height}
              {...restProps}
            />
          )}
        </AutoSizer>
      );
    }
    return <Base ref={ref} width={width} height={height} {...restProps} />;
  },
);

export default List;
